import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M34.6 41.2c-1.8 0-2.8-.5-3.6-1-.7-.4-1.2-.7-2.4-.7V37c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7s1.7-.3 2.4-.7c.8-.4 1.8-1 3.6-1v2.5c-1.2 0-1.7.3-2.4.7-.8.4-1.8 1-3.6 1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M10.4 41.2c-1.8 0-2.8-.5-3.6-1-.7-.4-1.2-.7-2.4-.7V37c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7s1.7-.3 2.4-.7c.8-.4 1.8-1 3.6-1v2.5c-1.2 0-1.7.3-2.4.7-.8.4-1.8 1-3.6 1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M4.4 37v2.5c-1.2 0-1.7.3-2.4.7-.4.2-.9.5-1.6.7-.2.1-.3.1-.4.1v-2.6c.2-.1.5-.2.7-.4.8-.4 1.8-1 3.7-1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M45 38.4V41c-.2 0-.3-.1-.5-.1-.6-.2-1-.5-1.4-.7-.7-.4-1.2-.7-2.4-.7V37c1.8 0 2.8.5 3.6 1 .2.2.5.3.7.4z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 21.2,
				y: 6.8,
				className: "icon-fill-secondary",
				width: 2.5,
				height: 5.4
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 21.2,
				y: 14.7,
				className: "icon-fill-secondary",
				width: 2.5,
				height: 5.4
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 21.2,
				y: 22.6,
				className: "icon-fill-secondary",
				width: 2.5,
				height: 5.4
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 21.2,
				y: 30.6,
				className: "icon-fill-secondary",
				width: 2.5,
				height: 5.4
			})
		] }),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "27.8 45 17.2 45 11.9 10.9 10.4 10.9 10.4 12.7 3.1 12.7 3.1 10.9 0 10.9 0 8.4 5.6 8.4 5.6 10.2 7.9 10.2 7.9 8.4 14 8.4 19.3 42.5 25.7 42.5 31 8.4 37.1 8.4 37.1 10.2 39.4 10.2 39.4 8.4 45 8.4 45 10.9 41.9 10.9 41.9 12.7 34.6 12.7 34.6 10.9 33.1 10.9"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-primary",
			points: "45 4.3 39.4 4.3 39.4 2.5 37.1 2.5 37.1 4.3 7.9 4.3 7.9 2.5 5.6 2.5 5.6 4.3 0 4.3 0 1.8 3.1 1.8 3.1 0 10.4 0 10.4 1.8 34.6 1.8 34.6 0 41.9 0 41.9 1.8 45 1.8"
		})
	]
});
export default SvgIcon;
